import {
    IWatchedItem,
    IWatcher,
    LevSettingsGetResponse,
    Ulid,
} from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";

const DEFAULT_SUPPLIER_SETTINGS = {
    _id: Ulid.ZERO,
    id: Ulid.ZERO.toString(),
    preliminary_entering: {
        project_purchase_account: "",
    },
};

export const makeSupplier = ({ connection, company }: ApiSliceParams) => {
    const loading = signal(false);
    const loaded = signal(false);
    const store = signal(DEFAULT_SUPPLIER_SETTINGS);
    let watcher: IWatcher<IWatchedItem<Ulid, LevSettingsGetResponse>> | null =
        null;

    const listen = () => {
        if (watcher) {
            return;
        }

        loading.value = true;

        watcher = connection.value.levsettings.get({ company: company.value });

        watcher.listen((value) => {
            const result = value.item;

            if (result) {
                const newValue = {
                    id: result.id.toString(),
                    _id: result.id,
                    preliminary_entering: {
                        project_purchase_account:
                            result.preliminary_entering
                                ?.project_purchase_account ?? "",
                    },
                };

                store.value = newValue;
            } else {
                store.value = DEFAULT_SUPPLIER_SETTINGS;
            }

            if (!loaded.peek()) {
                loaded.value = true;
                loading.value = false;
            }

            return true;
        });
    };

    return {
        store,
        listen,
    };
};
